<template>
  <div class="h-100">
    <b-jumbotron header="Dashboard" lead="Do stuff here!"></b-jumbotron>  
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>